import md5 from 'md5';

export const getHash = () => {
  return md5(new Date().getTime().toString());
};
